import React from "react";

const EtransferOptions = (props) => {
  const options = [
    {
      text: 'Help, I sent money via an INTERAC e-Transfer and I need to speak with someone. Who do I contact?',
      handler: props.actionProvider.handleEtransfer1,
      id: 1,
    },
    {
      text: 'Is paying with INTERAC e-Transfer the same as paying by INTERAC Debit or Interac Debit for online payments?',
      handler: props.actionProvider.handleEtransfer2,
      id: 2,
    },
    {
      text: 'How do I send money via INTERAC e-Transfer?',
      handler: props.actionProvider.handleEtransfer3,
      id: 3,
    },
    {
      text: 'How do I cancel an INTERAC e-Transfer transaction?',
      handler: props.actionProvider.handleEtransfer4,
      id: 4,
    },
    {
      text: 'I need to cancel a transfer, but the recipient has already accepted the deposit. How do I reverse an INTERAC e-Transfer transaction?',
      handler: props.actionProvider.handleEtransfer5,
      id: 5,
    },
    {
      text: 'I received a notification that I’m being sent money via INTERAC e-Transfer. How do I deposit the funds?',
      handler: props.actionProvider.handleEtransfer6,
      id: 6,
    },
    {
      text: 'How secure is it to send money by email or text message through INTERAC e-Transfer?',
      handler: props.actionProvider.handleEtransfer7,
      id: 7,
    },
    {
      text: 'Autodeposit',
      handler: props.actionProvider.handleAutodeposit,
      id: 8
    },
    {
      text: 'Request Money',
      handler: props.actionProvider.handleRequestMoney,
      id: 9
    },
    {
      text: 'International Transfers',
      handler: props.actionProvider.handleIntlTransfersOptions,
      id: 10
    },
    {
      text: 'Security',
      handler: props.actionProvider.handleetransferSecurity,
      id: 11
    },
    {
      text: 'Support',
      handler: props.actionProvider.handleSupport,
      id: 12
    },
  ];

  const optionsMarkup = options.map((option) => (
    <label key={option.text.replace(/\s+/g, '-').toLowerCase()}>
    <input
      type="radio"
      className='consumer-product-button'
      value={option.id}
      name="consumer"
      onClick={option.handler}
    />
    
    <span className={option.text.replace(/\s+/g, '-').toLowerCase()}>{option.text}</span>
      </label>
  ));

  return <div className='consumer-products-container etransfer-products'>{optionsMarkup}</div>;
};

export default EtransferOptions;